import { IDmSnsMsgSetting } from '@blcloud/bl-datamodel';

/** DMSNSメッセージ本文タイプ */
export enum DmSnsMsgBodyType {
  /** テキスト */
  Text = '0',
  /** 画像 */
  Image = '1',
  /** フレックスメッセージ */
  FlexMessage = '2'
}

/** コンテキストメニュー */
export enum ContextMenu {
  /** 追加 */
  Add,
  /** 削除 */
  Delete,
  /** 上移動 */
  Up,
  /** 下移動 */
  Down
}

/** DMSNSメッセージ設定拡張 */
export interface DmSnsMsgSettingEx {
  /** DMSNSメッセージ設定 */
  dmSnsMsgSetting: IDmSnsMsgSetting;
  /** ファイル */
  file: File | null;
  /** 本文文字数カウント */
  count: number;
  /** 本文スタイルフラグ */
  isStyleDisabled: boolean;
  /** 表示用LINEメッセージテンプレート名称 */
  dispLineMsgTemplateName: string;
  /** LINEメッセージテンプレート画像URL */
  lineMsgTemplateImageUrl: string;
  /** フレックスメッセージに件名設定可能か */
  isEnabledSetTitleInFlex: boolean;
  /** フレックスメッセージに件名2設定可能か */
  isEnabledSetTitle2InFlex: boolean;
  /** フレックスメッセージに件名3設定可能か */
  isEnabledSetTitle3InFlex: boolean;
  /** フレックスメッセージにラベル設定可能か */
  isEnabledSetLabelInFlex: boolean;
  /** フレックスメッセージにラベル2設定可能か */
  isEnabledSetLabel2InFlex: boolean;
  /** フレックスメッセージに本文設定可能か */
  isEnabledSetBodyInFlex: boolean;
  /** フレックスメッセージにフッター設定可能か */
  isEnabledSetFooterInFlex: boolean;
  /** フレックスメッセージにフッター2設定可能か */
  isEnabledSetFooter2InFlex: boolean;
  /** フレックスメッセージに画像設定可能か */
  isEnabledSetImageInFlex: boolean;
  /** テキストメッセージ本文入力エリア最終選択開始位置 */
  normalTextInputViewLastSelectionStart: number;
  /** テキストメッセージ本文入力エリア最終選択終了位置 */
  normalTextInputViewLastSelectionEnd: number;
  /** フレックスメッセージ件名入力エリア最終選択開始位置 */
  flexTitleInputViewLastSelectionStart: number;
  /** フレックスメッセージ件名入力エリア最終選択終了位置 */
  flexTitleInputViewLastSelectionEnd: number;
  /** フレックスメッセージ件名2入力エリア最終選択開始位置 */
  flexTitle2InputViewLastSelectionStart: number;
  /** フレックスメッセージ件名2入力エリア最終選択終了位置 */
  flexTitle2InputViewLastSelectionEnd: number;
  /** フレックスメッセージ件名3入力エリア最終選択開始位置 */
  flexTitle3InputViewLastSelectionStart: number;
  /** フレックスメッセージ件名3入力エリア最終選択終了位置 */
  flexTitle3InputViewLastSelectionEnd: number;
  /** フレックスメッセージラベル入力エリア最終選択開始位置 */
  flexLabelInputViewLastSelectionStart: number;
  /** フレックスメッセージラベル入力エリア最終選択終了位置 */
  flexLabelInputViewLastSelectionEnd: number;
  /** フレックスメッセージラベル2入力エリア最終選択開始位置 */
  flexLabel2InputViewLastSelectionStart: number;
  /** フレックスメッセージラベル2入力エリア最終選択終了位置 */
  flexLabel2InputViewLastSelectionEnd: number;
  /** フレックスメッセージフッター入力エリア最終選択開始位置 */
  flexFooterInputViewLastSelectionStart: number;
  /** フレックスメッセージフッター入力エリア最終選択終了位置 */
  flexFooterInputViewLastSelectionEnd: number;
  /** フレックスメッセージフッター2入力エリア最終選択開始位置 */
  flexFooter2InputViewLastSelectionStart: number;
  /** フレックスメッセージフッター2入力エリア最終選択終了位置 */
  flexFooter2InputViewLastSelectionEnd: number;
  /** フレックスメッセージ本文入力エリア最終選択開始位置 */
  flexTextInputViewLastSelectionStart: number;
  /** フレックスメッセージ本文入力エリア最終選択終了位置 */
  flexTextInputViewLastSelectionEnd: number;
}



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/content/sns-send-message-content.interface.ts